import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page4RA1.webp";
import Carousel1Image2 from "../assets/Page4RA3.webp";

import LD from "../assets/Page4LD.webp";
import LB from "../assets/Page4LB.webp";

//@ts-ignore
import LA from "../assets/Page4LA.mp4";
//@ts-ignore
import LC from "../assets/Page4LC.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2];

const Page4 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { xs: "100vh", sm: "50vh" },
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "50vh", sm: "100%" },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "50% 50%",
                      }}
                      src={LA}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                    height: {
                      sm: "100%",
                    },
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "46vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                      src={LC}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "45vh", sm: "50vh" },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${LB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9.1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35.5vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      showArrows={true}
                      showDots={true}
                      autoplay={true}
                    />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },

                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        paddingRight: "2vw",
                        paddingLeft: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "5vh" },
                      },
                    }}
                  >
                    The primary bedroom offers a serene blend of comfort, calm,
                    and elegance. Bathed in natural light from the charming bay
                    windows, the room feels open and inviting, with plenty of
                    space for restful nights and peaceful mornings. The soft,
                    neutral palette enhances the tranquil atmosphere, making it
                    an ideal retreat from the bustle of daily life. With its
                    spacious layout and thoughtful design, this room provides
                    the perfect balance of relaxation and personal space,
                    creating a quiet sanctuary where you can truly unwind.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page4;
